import React from 'react';

// presence
// 0 - disconnected
// 1 - reconnecting
// 2 - connected

// links to growl notifications
let growlConnectionErrors : any[] = [];

export default class Connectivity extends React.Component<any, any> {

    public eventListner     : any

    constructor(props:any) {
        super(props);

        this.state = {
            presenceStatus: gd.presence.status
        };
    }

    componentDidMount() {
        this.createEventListners();
    }

    componentWillUnmount() {
        this.destroyEventListners();
    }

    createEventListners = () => {
        this.eventListner = this.onPresenceStatusChanged;
        gd.presence.on("change:status",this.eventListner);
    };

    destroyEventListners = () => {
        gd.presence.off("change:status",this.eventListner);
    };

    onPresenceStatusChanged = (presence:any, newStatus:number) => {
        if (newStatus === 0) growlConnectionErrors.push(gd.growl.connectionError(
            <span>You have been disconnected from the server. <span className="link-button" onClick={this.onClick}>Reconnect.</span></span>
        ));

        if (newStatus === 2 && growlConnectionErrors.length > 0) {
            growlConnectionErrors.forEach(gce => gd.growl.removeNotification(gce));
            growlConnectionErrors = [];
        }

        this.setState({
            presenceStatus: newStatus
        })
    };

    onClick = () => {
        gd.presence.reconnectManual();
    };

    render() {

        const classes = Classes("ui-connectivity", {
            'reconnect': this.state.presenceStatus === 1,
            'disconnected': this.state.presenceStatus === 0
        });

        return (
            <div className={classes} onClick={this.onClick}>
                <div className="i5-plug"></div>
            </div>
        );
    }
}
